import { render, staticRenderFns } from "./CommonMiniListAccount.vue?vue&type=template&id=38a61d08&scoped=true"
import script from "./CommonMiniListAccount.vue?vue&type=script&lang=js"
export * from "./CommonMiniListAccount.vue?vue&type=script&lang=js"
import style0 from "./CommonMiniListAccount.vue?vue&type=style&index=0&id=38a61d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a61d08",
  null
  
)

export default component.exports